import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import AdminRoutes from "./Routes/AdminRoutes";
import FontRoutes from "./Routes/FontRoutes";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* ✅ ADMIN  ROUTES*/}
          <Route path="/admin/*" element={< AdminRoutes />} />
          <Route path="/*" element={< FontRoutes />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
